export default ConsultaController;

/** @ngInject */
function ConsultaController($state) {

  let vm = this;

  vm.limparFiltro = limparFiltro;

  vm.tab = $state.includes('consulta.empresas') ? 1 : 0;

  function limparFiltro() {
    vm.tab === 0 ? vm.limparFiltroFretes() : vm.limparFiltroEmpresas();
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/consulta.controller.ts
 **/